var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"color":_vm.colorCode,"text-color":_vm.textColor}},[_c('span',[_vm._v(_vm._s(_vm.startTime))]),_c('span',{staticClass:"mx-1"},[_vm._v("-")]),_c('span',[_vm._v(_vm._s(_vm.endTime))])])}
var staticRenderFns = []

export { render, staticRenderFns }